import { render, staticRenderFns } from "./GameStatisticsTable.vue?vue&type=template&id=33f25917&scoped=true&"
import script from "./GameStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./GameStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./GameStatisticsTable.vue?vue&type=style&index=0&id=33f25917&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f25917",
  null
  
)

export default component.exports